import defaultState from "./state";
import caracteristicas from "../GrillaBusquedaPQ/state"

const editarPaqueteFormReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CONFIRMACION_GUARDADO_EDICION": {
      return Object.assign({}, state, {
        aceptaGuardadoModal: action.aceptaGuardadoModal,
      });
    }
    case "CARGAR_DETALLE_PRESTACION": {
      if (action.detallePrestacion && action.detallePrestacion.length > 0) {
        const detallePrestacion = Object.assign({}, state.detallePrestacion, {
          codigoPrestacionPrestador: action.detallePrestacion[0].ARPR_PRES_CCOD_PRESTADOR,
          pabellonPrestacion: action.detallePrestacion[0].GUARISMO,
          glosaPrestacionPrestador: action.detallePrestacion[0].ARPR_PRES_TDESC_PRESTAD,
          codigoFonasa: action.detallePrestacion[0].COD_FONASA,
          grupoPrestacionIsapre: action.detallePrestacion[0].GRBA_CCOD,
          codigoPrestacionIsapre: action.detallePrestacion[0].COD_ISAPRE,
          glosaPrestacionIsapre: action.detallePrestacion[0].PRES_TDESC,
          codigoProfesional: action.detallePrestacion[0].PROF_CCOD,
          montoArancelPrestacion: null, // action.detallePrestacion[0].ARPR_MARANCEL,
          unidadArancelPrestacion: action.detallePrestacion[0].UNID_CCOD,
          inicioVigenciaArancelPrev: action.detallePrestacion[0].ARPR_FINICIAL,
          tipoAtencion: action.detallePrestacion[0].TIPO_ATENCION,
          grupoPrestacionPrestador: action.detallePrestacion[0].GRBA_CCOD,
          itemImed: action.detallePrestacion[0].ITEM_IMED,
          glosagGupoPrestacionIsapre: action.detallePrestacion[0].GRBO_DESCRIPCION,
          idPrestacion: action.detallePrestacion[0].ID_PRESTACION,
        });
        return Object.assign({}, state, {
          detallePrestacion,
        });
      }
      return state;
    }

    case "CAMBIAR_VIGENCIA_PRESTACION_EDICION": {
      return Object.assign({}, state, {
        vigenciaPrestacionEdicion: action.vigenciaPrestacionEdicion,
        inicioVigenciaArancelErr: action.error,
      });
    }

    case "CAMBIAR_VALOR_PRES": {
      const valorPrestacionAux = action.valorPrestacion;
      return Object.assign({}, state, {
        valorPrestacion: valorPrestacionAux,
      });
    }

    case "GUARDAR_VALOR_ARANCEL_MOD": {
      const valoresArancelesAux = state.valoresAranceles;
      const elementV = valoresArancelesAux.filter((v) => v.id === action.id);
      if (!elementV || elementV.length > 0) {
        valoresArancelesAux.pop(elementV);
      } // else { valoresArancelesAux.push({ id: action.id, valor: action.valor }); }
      valoresArancelesAux.push({ id: action.id, valor: action.valor });

      return Object.assign({}, state, {
        valoresAranceles: valoresArancelesAux,
      });
    }

    case "GUARDAR_VALOR_PRESTACIONES_MOD": {
      const prestacionesSeleccionadas = state.prestacionesSeleccionadas
        .map((p) => Object.assign({}, p, {
          Valor: action.id == p.IdPrestacion ?
            action.value : p.Valor,
          ValorError: action.id == p.IdPrestacion ?
            action.error : p.ValorError,
        }));

      return Object.assign({}, state, {
        prestacionesSeleccionadas,
      });
    }

    case "GUARDAR_VALOR_PRESTACIONES_MOD_ERR": {
      const valoresPrestacionesErrAux = state.valoresPrestacionesErr;
      valoresPrestacionesErrAux[action.id] = action.valor;
      return Object.assign({}, state, {
        valoresPrestacionesErr: valoresPrestacionesErrAux,
      });
    }

    case "GUARDAR_ARBOL_INICIAL_MOD": {
      const prestacionesSeleccionadas = [];

      action.tiposArancelPrestacion.forEach((arancel) => {
        action.centrosAtencionPrestacion.forEach((centro) => {
          if (arancel.Rut === centro.Rut) {
            prestacionesSeleccionadas.push({
              rutArancel: arancel.Rut,
              centroAtencion: centro.Secuencia,
              DescArancel: arancel.Descripcion,
              DescCentro: centro.Descripcion,
              IdPrestacion: centro.IdPrestacion,
              Selected: false,
              Valor: centro.Valor,
              ValorOld: centro.Valor,
              Unidad: centro.Unidad,
              UnidadOld: centro.Unidad,
              ValorError: "",
              UnidadError: "",
            });
          }
        });
      });

      return Object.assign({}, state, {
        prestacionesSeleccionadas,
      });
    }

    case "CAMBIAR_UNIDAD_GRILLA_MOD": {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas
          .map((p) => Object.assign({}, p, {
            Unidad: p.IdPrestacion === action.id ?
              action.value : p.Unidad,
            UnidadError: p.IdPrestacion === action.id ?
              action.error : p.UnidadError,
          })),
      });
    }

    case "CARGAR_CENTROS_PRESTACION": {
      const centrosAtencionPrestacionAux = [];
      const tiposArancelPrestacionAux = [];
      // const det = action.detalleCentros;
      action.detalleCentros.forEach((arancel) => {
        const rutAux = arancel.RutArancel;
        const elementV = tiposArancelPrestacionAux.filter((v) => v.RutArancel === rutAux);
        if (!elementV || elementV.length > 0) {
          tiposArancelPrestacionAux.pop(elementV);
        }

        let repetido = false;
        tiposArancelPrestacionAux.forEach((tipoprestacion) => {
          if (tipoprestacion.Rut === arancel.RutArancel) {
            repetido = true;
          }
        });
        if (!repetido) {
          tiposArancelPrestacionAux.push({ Rut: arancel.RutArancel, Descripcion: arancel.DescripcionArancel });
        }
        centrosAtencionPrestacionAux.push({
          Rut: arancel.RutArancel, Secuencia: arancel.Secuencia, Descripcion: arancel.Descripcion, Valor: arancel.MontoPrestacion, Unidad: arancel.Unidad, DescPrestacion: arancel.DescripcionPrestacion, FechaInicio: arancel.FechaInicio, FechaTermino: arancel.FechaTermino, IdPrestacion: arancel.IdPrestacion, tipoAtencion: arancel.tipoAtencion,
        });
      });
      return Object.assign({}, state, {
        centrosAtencionPrestacion: centrosAtencionPrestacionAux,
        tiposArancelPrestacion: tiposArancelPrestacionAux,
      });
    }

    case "OPEN_CARGAR_BORRADOR_EDITAR_PRESTACION": {
      return Object.assign({}, state, {
        loading: false,
        aceptaGuardadoModalEdicion: action.aceptaGuardadoModalEdicion,
      });
    }

    case "CHECK_ROWS_MOD_ARANCEL": {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas.map(p => {
          p.Selected = action.arancel == p.rutArancel ? action.checked : p.Selected

          return p
        })
      })
    }

    case "CHECK_ROWS_MOD": {
      if (action.rutArancel) {
        if (action.centroAtencion == null || typeof action.centroAtencion == "undefined") {

          return Object.assign({}, state, {
            prestacionesSeleccionadas: state.prestacionesSeleccionadas
              .map((p) => {
                Object.assign({}, p, {
                  Selected: action.id != null ?
                    action.id === p.IdPrestacion ? action.checked : p.Selected
                    :
                    action.rutArancel === p.rutArancel ? action.checked : p.Selected
                })
              }),
          });

        } else {
          return Object.assign({}, state, {
            prestacionesSeleccionadas: state.prestacionesSeleccionadas
              .map((p) => Object.assign({}, p, {
                Selected: action.id != null ?
                  action.id === p.IdPrestacion ? action.checked : p.Selected
                  :
                  action.rutArancel === p.rutArancel ? action.checked : p.Selected
              })),
          });
        }
      } else {
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, { Selected: action.id === p.idPrestacion ? action.checked : p.Selected })),
        });
      }
    }

    case "CAMBIAR_UNIDAD_REPLICAR_MOD": {
      const valorUnidadReplicarAux = action.tipoUnidad;
      return Object.assign({}, state, {
        tipoUnidadReplicar: valorUnidadReplicarAux,
      });
    }

    case "EDIT_PRESTACION/CAMBIAR_MONTO_ARANCEL_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        montoArancelPrestacion: action.montoArancelPrestacion,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "EDIT_PRESTACION/CAMBIAR_MONTO_ARANCEL_ERROR": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        montoArancelError: action.errorArancelPrestacion,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "CARGAR_VALOR_MAX_PRES_MOD": {
      const valorMaxPresAux = action.valorMaxPres;
      return Object.assign({}, state, {
        valorMaxPres: valorMaxPresAux,
      });
    }

    case "EDITAR_PREST/LIMPIAR_ERROR_GRILLA_UNSELECT": {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas
          .map((p) => Object.assign({}, p, {
            ValorError: !p.Selected ? "" : p.ValorError,
            UnidadError: !p.Selected ? "" : p.UnidadError,
          })),
      });
    }

    case "EDIT_PREST/DISPLAY_ERROR_TEXT": {
      return Object.assign({}, state, {
        inicioVigenciaArancelErr: action.Errors.InicioVigenciaArancelErr,
      });
    }

    case "EDIT_PREST/LOADING_ARBOL_DETALLE": {
      return Object.assign({}, state, {
        loadingArbolDetalle: action.load,
      });
    }

    case "EDIT_PREST/SHOW_DUPS_MSG": {
      return Object.assign({}, state, {
        dupsMsg: action.dupsMsg
      })
    }

    case "CARGAR_CARACTERISTICAS_MOD": {
      return Object.assign({}, state, {
        caracteristicadMod: action.caracteristicas,
      });
    }

    case "EDIT_PAQUETE/CAMBIAR_CARACTERISTICA": {
      var newArray = [];
      const caracteristicasAct = state.caracteristicadMod;
      //console.log(caracteristicasAct)

      const result = caracteristicasAct.filter(tipos => tipos.Tipo != action.tipo);

      newArray = result;
      newArray.push({ Tipo: action.tipo, Descripcion: action.descripcion });

      return Object.assign({}, state, {
        caracteristicadMod: newArray
      })
    }

    case "CAMBIAR_TIPO_CATACTERISTICA": {
      return Object.assign({}, state, {
        nuevaCaracteristica: action.nuevaCaracteristica,
        nuevaCaracteristicaDesc: "0",
      });
    }

    case "CAMBIAR_DESC_CATACTERISTICA": {
      return Object.assign({}, state, {
        nuevaCaracteristicaDesc: action.nuevaCaracteristicaDesc,
      });
    }

    case "CAMBIAR_PRES_SELECCIONADAS": {
      return Object.assign({}, state, {
        prestacionesSeleccionadasPQ: action.prestacionesSeleccionadasPQ,
      });
    }

    case "ABRIR_MODAL_ADD_CARACTERISTICAS": {
      return Object.assign({}, state, {
        openModalAddCaracteristicas: action.estado,
      })
    }

    case "ABRIR_MODAL_DETALLE": {
      return Object.assign({}, state, {
        openModalEditarPrestacion: action.estado,
      })
    }

    case "ABRIR_MODAL_NUEVA_PRESTACION": {
      return Object.assign({}, state, {
        openModalAddPrestacion: action.estado,
      })
    }

    case "DISPLAY_ERROR_TIPO": {
      return Object.assign({}, state, {
        errorCaract: action.errorCaract,
      });
    }

    case "DISPLAY_ERROR_DESC": {
      return Object.assign({}, state, {
        errorDesc: action.errorDesc,
      });
    }

    case "DISPLAY_ERROR_PRES": {
      return Object.assign({}, state, {
        errorPrestacion: action.errorPres,
      });
    }

    default:
      return state;
  }
};


export default editarPaqueteFormReducer;



// WEBPACK FOOTER //
// ./src/components/Paquetes/EditarPrestacionForm/reducer.js